import { createFeatureSelector, createSelector } from '@ngrx/store';
import { AdminState } from 'src/app/admin/store/admin.state';
import { AdminFeatureKey } from 'src/app/admin/store/admin.selectors';
import { selectRouteParams } from 'src/app/core/router.selectors';

export const selectCloneUserFeature = createFeatureSelector<AdminState>(AdminFeatureKey);

export const selectCloneUserState = createSelector(
    selectCloneUserFeature,
    (state) => state.cloneUserState
);

export const selectEmployees = createSelector(selectCloneUserState, (state) => state.employee);

export const selectClonedUser = createSelector(selectCloneUserState, (state) => state.clonedUser);

export const selectCloneUserId = createSelector(selectRouteParams, ({ id }) => id);

export const selectHasCloneRestrictedPermissions = createSelector(
    selectCloneUserState,
    (state) => state.hasCloneRestrictedPermission
);

export const selectCloneCoreApiPermissions = createSelector(
    selectCloneUserState,
    (state) => state.cloneCoreApiPermissions
);
